module.exports = __webpack_public_path__ + "static/img/case2.93bc08e9.svg";